import WeaLocaleProvider from "../../wea-locale-provider";

const getLabel = WeaLocaleProvider.getLabel;

// 对底层增加的多语言
export const lanOfCk = {
  pastefromword: {
    pasteWpsError: getLabel(
      "515725",
      "无法解析从WPS中复制的图片, 建议你单张复制或者手动上传"
    ),
    pasteError: getLabel("515726", "图片地址解析失败,请手动上传")
  },
  textindent: {
    labelName: getLabel("516051", "首行缩进")
  }
};



// WEBPACK FOOTER //
// ./ecology9/wea-rich-text/util/lan.js